<template>
    <div class="tours__filters">
        <a href="#" class="toggle_filters toggle_filters--close"><svg id="Group_21692" data-name="Group 21692" xmlns="http://www.w3.org/2000/svg" width="30.139" height="30.139" viewBox="0 0 30.139 30.139"><path id="Path_34567" data-name="Path 34567" d="M13.971,0,6.994,6.935,0,.175" transform="translate(22.307 18.293) rotate(180)" fill="none" stroke="#072646" stroke-width="3"/></svg></a>
        <a href="#" @click.prevent="resetFilters()" class="toggle_filters toggle_filters--reset"><svg xmlns="http://www.w3.org/2000/svg" width="30" height="33.096" viewBox="0 0 30 33.096"><path id="Path_34723" data-name="Path 34723" d="M30.414,15.524a2.586,2.586,0,0,0-2.586,2.586A9.828,9.828,0,1,1,18,8.283a2.61,2.61,0,0,0,.362-.036V11.49a.517.517,0,0,0,.879.362l5.483-5.483a.554.554,0,0,0-.052-.724L19.241.162a.517.517,0,0,0-.879.362V3.147A2.533,2.533,0,0,0,18,3.111a15,15,0,1,0,15,15A2.586,2.586,0,0,0,30.414,15.524Z" transform="translate(-3 -0.015)" fill="#072646"/></svg></a>
        <div class="tours__filters__card tours__filters__card--destination tours__filters__card--big" v-if="filterdata.tour_destinations">
            <div class="tours__filters__card__upper">
                <span>{{translations.destinations}}</span>
            </div>
            <div class="tours__filters__card__lower">
                <div class="tours__filters__card__lower__cat">
                    <ul class="tours__filters__list tours__filters__list--vertical">
                        <li v-for="destination in filterdata.tour_destinations" :key="destination.id" v-if="!destination.roundtrip && !destination.outofathens">
                            <input type="checkbox" :disabled="destination.tours_count == 0" :id="'destination_'+destination.id" name="destinations" @change="filter_tours" v-model="filters.destinations" :value="destination.id">
                            <label :for="'destination_'+destination.id">{{ destination.namejs[lang] | remove_parenthesis}} <span>{{ destination.tours_count }}</span></label>
                        </li>
                    </ul>
                </div>
                <div class="tours__filters__card__lower__cat">
                    <h4>{{translations.round_trips}}</h4>
                    <ul class="tours__filters__list tours__filters__list--vertical">
                        <li v-for="destination in filterdata.tour_destinations" :key="destination.id" v-if="destination.roundtrip">
                            <input type="checkbox" :disabled="destination.tours_count == 0" :id="'destination_'+destination.id" name="destinations" @change="filter_tours" v-model="filters.destinations" :value="destination.id">
                            <label :for="'destination_'+destination.id">{{ destination.namejs[lang] | remove_parenthesis}} <span>{{ destination.tours_count }}</span></label>
                        </li>
                    </ul>
                </div>
                <div class="tours__filters__card__lower__cat">
                    <h4>{{translations.out_of_athens}}</h4>
                    <ul class="tours__filters__list tours__filters__list--vertical">
                        <li v-for="destination in filterdata.tour_destinations" :key="destination.id" v-if="destination.outofathens">
                            <input type="checkbox" :disabled="destination.tours_count == 0" :id="'destination_'+destination.id" name="destinations" @change="filter_tours" v-model="filters.destinations" :value="destination.id">
                            <label :for="'destination_'+destination.id">{{ destination.namejs[lang] | remove_parenthesis}} <span>{{ destination.tours_count }}</span></label>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
        <div class="tours__filters__card" v-if="filterdata.tour_durations">
            <div class="tours__filters__card__upper">
                <span>{{translations.durations}}</span>
            </div>
            <div class="tours__filters__card__lower">
                <ul class="tours__filters__list tours__filters__list--vertical">
                    <li v-for="duration in filterdata.tour_durations" :key="duration.id">
                        <input type="checkbox" :disabled="duration.tours_count == 0" :id="'duration_'+duration.id" name="durations" @change="filter_tours" v-model="filters.durations" :value="duration.id">
                        <label :for="'duration_'+duration.id">{{ duration.name[lang]}} <span>{{ duration.tours_count }}</span></label>
                    </li>
                </ul>
            </div>
        </div>
        <div class="tours__filters__card" v-if="filterdata.tour_interests">
            <div class="tours__filters__card__upper">
                <span>{{translations.interests}}</span>
            </div>
            <div class="tours__filters__card__lower">
                <ul class="tours__filters__list tours__filters__list--vertical">
                    <li v-for="interest in filterdata.tour_interests" :key="interest.id">
                        <input type="checkbox" :disabled="interest.tours_count == 0" :id="'interest_'+interest.id" name="interests" @change="filter_tours" v-model="filters.interests" :value="interest.id">
                        <label :for="'interest_'+interest.id">{{ interest.name[lang]}} <span>{{ interest.tours_count }}</span></label>
                    </li>
                </ul>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        props: ['filterdata', 'translations'],
        data() {
            return {
                lang: "en",
                filters: {
                    destinations: [],
                    durations: [],
                    interests: [],
                }
            }
        },
        created() {
            window.onpopstate = (event) => {
                this.checkIfUrlHasFilters();
                this.$emit('filter_tours', this.filters);
            };
        },
        methods: {
            filter_tours() {
                this.appendToUrl();
                this.$emit('filter_tours', this.filters);
            },
            resetFilters() {
                this.filters.destinations = [];
                this.filters.durations = [];
                this.filters.interests = [];
                console.log(this.filters)
                this.appendToUrl();
                this.$emit('filter_tours', this.filters);
            },
            checkIfUrlHasFilters() {
                const params = new URLSearchParams(window.location.search);
                if(!params.toString()) {
                    this.filters.destinations = [];
                    this.filters.interests = [];
                    this.filters.durations = [];
                }
                console.log(params.toString());
                for (let p of params) {
                    if(p[0] == 'destinations[]') {
                        this.filters.destinations = p[1].split(',');
                    } else {
                        this.filters.destinations = [];
                    }
                    if(p[0] == 'interests[]') {
                        this.filters.interests = p[1].split(',');
                    } else {
                        this.filters.interests = [];
                    }
                    if(p[0] == 'durations[]') {
                        this.filters.durations = p[1].split(',');
                    } else {
                        this.filters.durations = [];
                    }
                }
            },
            appendToUrl() {
                let has_value=false;
                let query_string = '?';
                if(this.filters.destinations.length > 0) {
                    query_string += `destinations[]=${this.filters.destinations}&`;
                    has_value=true;
                }
                if(this.filters.interests.length > 0) {
                    query_string += `interests[]=${this.filters.interests}&`;
                    has_value=true;
                }
                if(this.filters.durations.length > 0) {
                    query_string += `durations[]=${this.filters.durations}`;
                    has_value=true;
                }
                if(has_value) {
                    window.history.pushState( {} , '', query_string );
                } else {
                    window.history.pushState({}, "", "/"+window.location.href.substring(window.location.href.lastIndexOf('/') + 1).split("?")[0]);

                }
            }
        },
        filters: {
            remove_parenthesis: function (value) {
                if (!value) return ''
                value = value.toString()
                return value.replace(/ *\([^)]*\) */g, "");
            }
        },
        mounted() {
            this.lang = document.documentElement.lang;
            this.checkIfUrlHasFilters();
        }
    }
</script>
